<p class="help-text" [innerHTML]="'HELP.CREATE_LIVE_STREAM' | translate"></p>

<h2>{{ 'CREATE_LIVE_STREAM' | translate }}</h2>

<div class="live-stream">
	<form #formRef="ngForm" class="create-live-stream" name="form" (submit)="createLiveStream($event)" novalidate>
		<bb-form-element [form]="form" label="{{'TITLE' | translate}}">
			<input [(ngModel)]="title" type="text" name="title" required />
		</bb-form-element>

		<bb-form-element [form]="form" label="{{'SOURCE_URL' | translate}}">
			<textarea [(ngModel)]="src" name="src" required></textarea>
		</bb-form-element>

		
		<bb-form-element [form]="form" label="{{'STREAM_TYPE' | translate}}">
			<bb-select [(ngModel)]="streamType" [options]="streamTypes" name="streamType" (ngModelChange)="mediatypes = this.determineMediatypes()"></bb-select>
		</bb-form-element>

		<div class="col-group">
			<bb-form-element [form]="form" label="{{'TYPE' | translate}}">
				<bb-select [(ngModel)]="mediaType" [options]="mediatypes" name="mediatype"></bb-select>
			</bb-form-element>

			<bb-form-element [form]="form" label="{{'BANDWIDTH' | translate}} ({{ 'KBPS' | translate }})">
				<input [(ngModel)]="bandwidth" type="number" name="bandwidth" />
			</bb-form-element>
		</div>

		<div class="col-group">
			<bb-form-element *ngIf="streamType === 'video'" [form]="form" label="{{'WIDTH' | translate}} ({{'PX' | translate}})">
				<input [(ngModel)]="width" type="number" name="width" />
			</bb-form-element>

			<bb-form-element *ngIf="streamType === 'video'" [form]="form" label="{{'HEIGHT' | translate}} ({{'PX' | translate}})">
				<input [(ngModel)]="height" type="number" name="height" />
			</bb-form-element>
		</div>

		<div class="input">
			<button [disabled]="!putRight" type="submit" class="button submit"><i
					class="fa fa-rocket" [ngClass]="{disabled: !putRight}"></i>{{ 'CREATE_LIVE_STREAM' | translate }}</button>
		</div>
	</form>
</div>
